import { Link } from "react-router-dom";
import { SERVICES, PACKAGES } from "@/data/site";
import { Star, Check, ArrowRight } from "lucide-react";

export default function Pricing() {
  return (
    <div data-testid="pricing-page" className="pt-32">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-6">
        <div className="font-display uppercase tracking-[0.3em] text-xs text-[#8DE038] mb-3">/ Pricing</div>
        <h1 className="font-display uppercase tracking-tighter text-5xl md:text-7xl text-[#F0F4F1] max-w-4xl">
          Transparent pricing. <br/><span className="text-[#8DE038]">No surprises.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-lg text-[#9CAEA3] leading-relaxed">Prices shown are starting prices from our network of vetted pros. Pay them direct on the day. Green Connect just charges a 10% platform fee (min £5) at booking.</p>
      </section>
      <div data-testid="discount-banner" className="bg-[#8DE038] text-[#050806] py-5 mt-8">
        <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row gap-3 items-center justify-between">
          <div className="font-display uppercase tracking-[0.2em] text-base md:text-lg flex items-center gap-3">
            <Star size={20} fill="#050806"/> 10% OFF for OAPs, NHS Staff & First-Time Customers
          </div>
        </div>
      </div>
      <section className="section-pad bg-[#050806]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 space-y-16">
          {SERVICES.map((s) => (
            <div key={s.slug} data-testid={`pricing-table-${s.slug}`}>
              <div className="flex items-end justify-between flex-wrap gap-4 mb-6">
                <h2 className="font-display uppercase tracking-tight text-3xl md:text-4xl text-[#F0F4F1] heading-accent">{s.name}</h2>
                <Link to={`/book?service=${s.slug}`} className="btn-secondary text-xs">Book Now <ArrowRight size={14}/></Link>
              </div>
              <div className="border border-[#1F3325]">
                {s.rows.map(([label, price], i) => (
                  <div key={label} className={`grid grid-cols-12 items-center px-5 md:px-7 py-4 ${i % 2 === 1 ? "bg-[#0A0F0B]" : "bg-[#0F1712]"}`}>
                    <div className="col-span-8 md:col-span-9 text-[#F0F4F1] font-medium">{label}</div>
                    <div className="col-span-4 md:col-span-3 text-right">
                      {price === "Quote Required" ? (
                        <span className="font-display uppercase tracking-widest text-xs text-[#8DE038] border border-[#8DE038]/40 px-2 py-1">Quote Required</span>
                      ) : (
                        <span className="font-display uppercase tracking-wider text-lg text-[#8DE038]">From {price}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div>
            <h2 className="font-display uppercase tracking-tight text-3xl md:text-4xl text-[#F0F4F1] heading-accent">Popular Packages</h2>
            <div className="grid md:grid-cols-3 gap-5 mt-6">
              {PACKAGES.map((p) => (
                <div key={p.name} className={`p-8 border ${p.highlight ? "border-[#8DE038]" : "border-[#1F3325]"} bg-[#0A0F0B] flex flex-col`}>
                  <div className="font-display uppercase tracking-widest text-xs text-[#9CAEA3]">{p.tagline}</div>
                  <div className="font-display uppercase text-4xl text-[#F0F4F1] mt-1">{p.name} Package</div>
                  <div className="font-display text-4xl text-[#8DE038] mt-2">{p.price}</div>
                  <ul className="mt-5 space-y-2 text-[#F0F4F1]">
                    {p.features.map((f) => (<li key={f} className="flex gap-2"><Check size={16} className="text-[#8DE038] mt-1"/>{f}</li>))}
                  </ul>
                  <Link to={`/book?package=${p.name.toLowerCase()}`} className="btn-primary text-xs mt-7 justify-center">Book {p.name}</Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
